import { serializeCommaSeparatedQueryParam } from '@helpers/serializeCommaSeparatedQueryParam';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { JobReportResponseDto } from 'app/API';
import { client } from 'app/http';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.reportList>>;

export const createFetchJobsReportQueryFn =
  () =>
  async ({ queryKey: [{ params }], signal }: TParams): Promise<JobReportResponseDto> => {
    const response = await client.get<JobReportResponseDto>('/admin/jobs-report', {
      params: {
        pageNo: params.page.toString(),
        pageSize: params.pageSize.toString(),
        orderBy: params.orderBy,
        orderType: params.orderType,
        statuses: serializeCommaSeparatedQueryParam(params.statuses),
        search: params.search,
        from: params.from,
        to: params.to,
        asOne: params.asOne,
        post: params.post,
        meetingTypes: serializeCommaSeparatedQueryParam(params.meetingTypes),
        durationFrom: params.durationFrom === undefined ? undefined : String(params.durationFrom),
        durationTo: params.durationTo === undefined ? undefined : String(params.durationTo),
        includeExternallyManaged: params.includeExternallyManaged,
      },
      signal,
    });

    return response.data;
  };
